/**
 * Route table. Every route renders inside Layout (branded header + footer).
 *
 * Public:  /            PublicHome
 *          /map         MapView      (painting tools, plan lifecycle, reference overlays)
 *          /coi         CoiSubmit    (placeholder form)
 *          /p/:token   SharedPlan   (public read-only shared plan: co-sign, fork)
 *          /p/coi/:token SharedCoi  (public read-only shared COI: co-sign, fork)
 *          /signup      SignUp       (native account registration)
 *          /signin      SignIn
 *          /verify-email VerifyEmail (email verification link landing)
 *          /forgot-password ForgotPassword
 *          /reset-password  ResetPassword
 * Staff:   /admin           AdminLogin     (staff sign-in, city-bound accounts)
 *          /admin/dashboard AdminDashboard (staff only)
 *          *            NotFound
 */
import { Route, Routes } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Layout } from '../components/Layout';
import { ErrorState } from '../components/ErrorState';
import { AdminDashboard } from '../pages/AdminDashboard';
import { AdminLogin } from '../pages/AdminLogin';
import { CoiSubmit } from '../pages/CoiSubmit';
import { ForgotPassword } from '../pages/ForgotPassword';
import { MapView } from '../pages/MapView';
import { PublicHome } from '../pages/PublicHome';
import { ResetPassword } from '../pages/ResetPassword';
import { SharedCoi } from '../pages/SharedCoi';
import { SharedPlan } from '../pages/SharedPlan';
import { SignIn } from '../pages/SignIn';
import { SignUp } from '../pages/SignUp';
import { VerifyEmail } from '../pages/VerifyEmail';

function NotFound(): JSX.Element {
  const { t } = useTranslation();
  return (
    <ErrorState
      title={t('common.pageNotFound')}
      message={t('common.pageNotFoundBody')}
    />
  );
}

export function AppRouter(): JSX.Element {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<PublicHome />} />
        <Route path="map" element={<MapView />} />
        <Route path="coi" element={<CoiSubmit />} />
        <Route path="p/coi/:token" element={<SharedCoi />} />
        <Route path="p/:token" element={<SharedPlan />} />
        <Route path="signup" element={<SignUp />} />
        <Route path="signin" element={<SignIn />} />
        <Route path="verify-email" element={<VerifyEmail />} />
        <Route path="forgot-password" element={<ForgotPassword />} />
        <Route path="reset-password" element={<ResetPassword />} />
        <Route path="admin" element={<AdminLogin />} />
        <Route path="admin/dashboard" element={<AdminDashboard />} />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
}
